import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=661214ab&scoped=true&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=661214ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661214ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661214ab')) {
      api.createRecord('661214ab', component.options)
    } else {
      api.reload('661214ab', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=661214ab&scoped=true&", function () {
      api.rerender('661214ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/template/shared/footer.vue"
export default component.exports